import React, { Component } from 'react';
import { connect } from 'react-redux';
import NavBar from '../layout/NavBar';
import {
  getOrderDetails,
  saveRemark,
  cancelOrder,
} from '../../services/api/get-pharmacy-orders';
import PharmacyCart from './PharmacyCart';
import { toast } from 'react-toastify';
import Modal from '../common/Modal';
import PharmacyClickToCallButton from './PharmacyClickToCallButton';
import ModalConfirm from '../common/ModalConfirm';
import PharmacyOrderCopayForm from './PharmacyOrderCopayForm';
import UserWallet from './UserWallet';
import CancelOrderModal from "./CancelOrderModal.jsx";
import ChangePartner from "./ChangePartner";
import PharmacyRefundAmount from "./PharmacyRefundAmount";

import CommentList from './comments/commentList';
import CommentForm from './comments/commentForm';
import appConfig from '../../config/app-config';
import {
  viewCommentRequest,
} from '../../services/api/get-pharmacy-orders';
import RetryOrder from './RetryOrder.jsx';
import ShowPharmacyCommsHistory from './ShowPharmacyCommsHistory.js';
import { getBlobUrl } from '../../utils/getBlobUrlAndContentType.js';

class PharmacyOrderDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderDetails: [],
      userDetails: {},
      orderAmount: {},
      deliveryDetail:{},
      cartId: null,
      loading: false,
      comments: [],
      userId: null,
      copayBlockerModal: {
        isOpen: false,
      },
      confirmModal: {
        isOpen: false,
        message: 'Are you sure. You want to cancel this order?',
        onConfirm: () => {},
        onClose: () => {},
      },
      openRetryModal : false,
      orderId: null,
      remarks: '',
      subOrderDetails: []
    };
  }

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const orderId = params.get('orderId');
    this.fetchCommentByOrderId(orderId);
    this.setState(
      {
        orderId,
      },
      this.getUserDetails
    );
  }
  getUserDetails = () => {
    const { userId, orderId } = this.state;
    if (!orderId) {
      return;
    }
    return getOrderDetails(orderId)
      .then(async (response) => {
        const details = response.body;
        console.log({ response }, '[getOrderDetails]');
        if (details.userDetails) { 
          details.userDetails.prescriptionUrl = await getBlobUrl(details.userDetails.prescriptionUrl);
        }
        this.setState({
          orderDetails: details.orderDetails,
          userDetails: details.userDetails || {},
          orderAmount: details.orderAmount || {},
          deliveryDetail: details.deliveryPersonDetail ||{},
          subOrderDetails: details.subOrderDetails || []
          // remarks: cartDetails.remarks || '',
        });
      })
      .catch((err) => {
        console.error('Error in loading user details', err);
        toast.error(`Unable to load User details`);
      });
  };
  openAddCopayModal = () => {
    this.setState(
      {
        copayBlockerModal: {
          isOpen: true,
        },
      },
      this.getUserDetails,
      this.fetchPharmacyCart
    );
  };
  openConfirmModal = () => {
    this.setState({
      confirmModal: {
        isOpen: true,
        message: 'Are you sure. You want to cancel this order?',
        onConfirm: () => {
          const { orderId } = this.state;
          return cancelOrder(orderId)
            .then((response) => {
              if (response.body.message === 'success') {
                toast.success('Order Cancelled');
              } else {
                const err = response.body.err;
                if (typeof err === 'string') {
                  toast.error(response.body.err);
                } else {
                  toast.error('Unable to cancel order');
                }
              }
              this.getUserDetails();
              return Promise.resolve();
            })
            .catch((err) => {
              console.error('Error in cancel order', err);
              toast.error('Unable to cancel order');
              return Promise.resolve();
            })

        },
        onClose: () => {
          this.setState({
            confirmModal: {
              isOpen: false,
              onConfirm: () => {},
              onClose: () => {},
            },
          });
        },
      },
    });
  };
  closeConfirmModal = () => {};
  closeAddCopayModal = () => {
    this.setState(
      {
        copayBlockerModal: {
          isOpen: false,
        },
      },
      this.getUserDetails,
      this.fetchPharmacyCart
    );
  };
  saveRemarks = () => {
    const { orderId, remarks } = this.state;
    return saveRemark(orderId, remarks)
      .then((response) => {
        if (response.body.message === 'success') {
          toast.success('Remark Saved');
        } else {
          toast.error(`Unable to save remarks`);
        }
      })
      .catch((err) => {
        console.error('Error in saving remarks', err);
        toast.error(`Unable to save remarks`);
      });
  };

  handleComments = (response) => {
    const comments = [];
    if (response.message === 'success' && response.data.length) {
      // build comments
      response.data.forEach((c) => {
        comments.push({
          name: c.userName,
          message: c.text,
          time: c.createdAt,
        });
      });
    }
    return comments;
  };

  fetchCommentByOrderId = (orderId) => {
    viewCommentRequest(orderId, appConfig.REQUEST_CHAT.INTERNAL)
      .then((response) => this.handleComments(response))
      .then((comments) => {
        // setting the state
        this.setState({
          comments,
          requestChat: {
            orderId,
          },
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  addComment = (comment) => {
    this.setState({
      loading: false,
      comments: [...this.state.comments, comment],
    });
  }

  fetchPharmacyCart = () => {
    return (
      <PharmacyCart
        orderDetails={this.state.orderDetails}
        orderAmount={this.state.orderAmount}
      />
    );
  };

  fetchUserWallet = () => {
    return (
      <UserWallet propOrderId={this.state.orderId} isStarHealthUser={this.state.userDetails.isStarPatient} starPolicyNo={this.state.userDetails.isStarPatient && this.state?.userDetails.starHealthPolicyNumber}/>
    )
  }

  toggleRetryModal = () => {
    this.setState({openRetryModal : !this.state.openRetryModal})
  }

  render() {
    const { orderId, comments, loading } = this.state;
    const u = this.state.userDetails;

    const card = {
      background: '#fff',
      border: '1px solid #E3E3E3',
      borderRadius: '8px',
      boxShadow: '0px 2px 8px rgba(0,0,0,0.06)',
      padding: '16px 20px',
      marginBottom: '16px',
    };
    const sectionLabel = {
      fontSize: '10px',
      fontWeight: 700,
      textTransform: 'uppercase',
      letterSpacing: '0.8px',
      color: '#A5A6BB',
      marginBottom: '12px',
    };
    const infoGrid = {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
      gap: '12px 24px',
    };
    const infoLabel = {
      fontSize: '11px',
      color: '#A5A6BB',
      fontWeight: 600,
      marginBottom: '2px',
    };
    const infoValue = {
      fontSize: '13px',
      color: '#0F0B28',
      fontWeight: 700,
      wordBreak: 'break-word',
    };

    return (
      <div style={{ background: '#F7F7F7', minHeight: '100vh', width: '100%', minWidth: 0 }}>
        <div className="container-fluid px-0">
          <div className="row no-gutters">
            <NavBar />
          </div>

          <div style={{ padding: '72px 16px 32px' }}>

            {/* ── Page Header ── */}
            <div style={{ ...card, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px', marginBottom: '16px' }}>
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                  <h1 style={{ margin: 0, fontSize: '20px', fontWeight: 700, color: '#0F0B28' }}>
                    Order #{orderId}
                  </h1>
                  {u.partnerName && (
                    <span style={{ background: '#E5E9FE', color: '#6C5DD3', fontSize: '12px', fontWeight: 600, borderRadius: '4px', padding: '2px 10px' }}>
                      {u.partnerName}
                    </span>
                  )}
                  {u.status && (
                    <span style={{
                      background: u.status === 'Failed' ? '#FFF0F0' : u.status === 'Completed' ? '#EDFAF4' : '#FFF3DC',
                      color: u.status === 'Failed' ? '#EB5757' : u.status === 'Completed' ? '#1eb865' : '#B07800',
                      fontSize: '12px', fontWeight: 600, borderRadius: '4px', padding: '2px 10px',
                    }}>
                      {u.status}
                    </span>
                  )}
                </div>
                {u.partnerBookingId && (
                  <p style={{ margin: '4px 0 0', fontSize: '12px', color: '#A5A6BB' }}>
                    Partner Booking ID: <strong style={{ color: '#585969' }}>{u.partnerBookingId}</strong>
                  </p>
                )}
              </div>
              {u.status === 'Failed' && (
                <button
                  style={{ height: '34px', padding: '0 18px', fontSize: '13px', fontWeight: 600, borderRadius: '6px', border: '1px solid #6C5DD3', background: '#6C5DD3', color: '#fff', cursor: 'pointer' }}
                  onClick={() => this.setState({ openRetryModal: true })}
                >
                  Retry Order
                </button>
              )}
            </div>

            {/* ── User Details ── */}
            <div style={card}>
              <div style={sectionLabel}>User Details</div>
              <div style={infoGrid}>
                <div>
                  <div style={infoLabel}>Name</div>
                  <div style={infoValue}>{u.userName || '—'}</div>
                </div>
                <div>
                  <div style={infoLabel}>Email</div>
                  <div style={infoValue}>{u.userEmail || '—'}</div>
                </div>
                <div>
                  <div style={infoLabel}>Phone</div>
                  <div style={infoValue}>
                    <PharmacyClickToCallButton orderId={orderId} phone={u.userPhone} />
                  </div>
                </div>
                <div>
                  <div style={infoLabel}>Sponsor</div>
                  <div style={infoValue}>{u.sponsorName || '—'}</div>
                </div>
                <div>
                  <div style={infoLabel}>Policy Holder</div>
                  <div style={infoValue}>{u.policyHolderName || '—'}</div>
                </div>
                <div>
                  <div style={infoLabel}>Dependent Names</div>
                  <div style={infoValue}>{u.patientName || '—'}</div>
                </div>
                <div>
                  <div style={infoLabel}>Dependent Relations</div>
                  <div style={infoValue}>{u.userRelations || '—'}</div>
                </div>
              </div>
            </div>

            {/* ── Patient Details ── */}
            <div style={card}>
              <div style={sectionLabel}>Patient Details</div>
              <div style={infoGrid}>
                <div>
                  <div style={infoLabel}>Name</div>
                  <div style={infoValue}>{u.patientName || '—'}</div>
                </div>
                <div>
                  <div style={infoLabel}>Gender</div>
                  <div style={infoValue}>{u.patientGender || '—'}</div>
                </div>
                <div>
                  <div style={infoLabel}>Age</div>
                  <div style={infoValue}>{u.patientAge || '—'}</div>
                </div>
                <div>
                  <div style={infoLabel}>Phone</div>
                  <div style={infoValue}>
                    <PharmacyClickToCallButton orderId={orderId} phone={u.patientPhone} />
                  </div>
                </div>
                <div style={{ gridColumn: 'span 2' }}>
                  <div style={infoLabel}>Address</div>
                  <div style={infoValue}>
                    {[u.addressTitle, u.address, u.locality, u.pincode].filter(Boolean).join(', ') || '—'}
                  </div>
                </div>
                <div>
                  <div style={infoLabel}>Digitisation ID</div>
                  <div style={infoValue}>{u.digitisationId || '—'}</div>
                </div>
                <div style={{ gridColumn: 'span 2' }}>
                  <div style={infoLabel}>Prescription</div>
                  <div style={infoValue}>
                    {u.prescriptionUrl
                      ? <a href={u.prescriptionUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#6C5DD3', fontWeight: 600, fontSize: '13px' }}>View Prescription ↗</a>
                      : '—'}
                  </div>
                </div>
              </div>
            </div>

            {/* ── Cart & Wallet ── */}
            <div style={card}>
              <div style={sectionLabel}>Cart Details</div>
              {this.fetchPharmacyCart()}
            </div>

            <div style={card}>
              <div style={sectionLabel}>Wallet</div>
              {this.fetchUserWallet()}
            </div>

            {/* ── Sub Orders ── */}
            {this.state.subOrderDetails && this.state.subOrderDetails.length > 0 && (
              <div style={card}>
                <div style={sectionLabel}>Sub Order Status</div>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                  <thead>
                    <tr style={{ background: '#F5F4FF' }}>
                      {['Sub Order ID', 'Status', 'Min Delivery', 'Max Delivery'].map(h => (
                        <th key={h} style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 700, color: '#585969', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: '1px solid #E3E3E3' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.subOrderDetails.map((s, i) => (
                      <tr key={i} style={{ borderBottom: '1px solid #F0F0F0' }}>
                        <td style={{ padding: '9px 12px', color: '#0F0B28', fontWeight: 600 }}>{s.partnerSubOrderId}</td>
                        <td style={{ padding: '9px 12px' }}>
                          <span style={{ background: '#E5E9FE', color: '#6C5DD3', borderRadius: '4px', padding: '2px 8px', fontSize: '11px', fontWeight: 600 }}>{s.partnerOrderStatus}</span>
                        </td>
                        <td style={{ padding: '9px 12px', color: '#585969', fontWeight: 600 }}>{s.minDeliveryTime}</td>
                        <td style={{ padding: '9px 12px', color: '#585969', fontWeight: 600 }}>{s.maxDeliveryTime}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* ── Transaction History ── */}
            {this.state.transactions && this.state.transactions.length > 0 && (
              <div style={card}>
                <div style={sectionLabel}>Transaction History</div>
                {this.state.transactions.map((t) => (
                  <div key={`${t.id}-${t.type}`} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 0', borderBottom: '1px solid #F0F0F0', fontSize: '13px', color: '#585969' }}>
                    <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: t.type === 'refund' ? '#1eb865' : '#6C5DD3', flexShrink: 0 }} />
                    <span><strong style={{ color: '#0F0B28' }}>{t.type === 'refund' ? 'Refund' : 'Copay'}</strong> of Rs.{t.amount} on {t.formattedDate}</span>
                    <span style={{ marginLeft: 'auto', fontSize: '11px', fontWeight: 600, color: '#A5A6BB' }}>{t.status}</span>
                  </div>
                ))}
              </div>
            )}

            {/* ── Comments ── */}
            <div style={card}>
              <div style={sectionLabel}>Internal Comments</div>
              <CommentList loading={loading} comments={comments} />
              <div style={{ marginTop: '12px' }}>
                <CommentForm
                  addComment={this.addComment}
                  orderId={orderId}
                  commentType={appConfig.PHARMACY.pharmacyOrder}
                />
              </div>
            </div>

            {/* ── Comms History ── */}
            <div style={card}>
              <div style={sectionLabel}>Communication History</div>
              <ShowPharmacyCommsHistory sourceId={orderId} />
            </div>

          </div>
        </div>

        <Modal header="Change Pricing" isOpen={this.state.copayBlockerModal.isOpen} onClose={this.closeAddCopayModal}>
          <PharmacyOrderCopayForm orderId={orderId} cartItemsResult={this.state.orderDetails} onSubmit={this.closeAddCopayModal} />
        </Modal>
        <ModalConfirm
          message={this.state.confirmModal.message}
          onConfirm={this.state.confirmModal.onConfirm}
          onClose={this.state.confirmModal.onClose}
          isOpen={this.state.confirmModal.isOpen}
        />
        {this.state.openRetryModal && <RetryOrder orderId={orderId} onClose={this.toggleRetryModal} />}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return;
}

export default connect(mapStateToProps)(PharmacyOrderDetails);
